import React from 'react';
import { Modal } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import useDeleteSingleMerchant from 'Hooks/query-hooks/single-merchant/useDeleteSingleMerchant';
import styles from './DeleteMerchantModal.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onSuccess?: () => void;
    merchantId: string;
    templateRepositoryId: number;
};

const DeleteMerchantModal = ({ isOpen, onClose, merchantId, onSuccess, templateRepositoryId }: Props) => {
    const { t } = useTranslation();

    const deleteSingleReport = useDeleteSingleMerchant(merchantId, templateRepositoryId);

    React.useEffect(() => {
        if (deleteSingleReport?.isSuccess) {
            onSuccess?.();
            onClose();
            deleteSingleReport.reset();
        }
        if (deleteSingleReport?.isError) {
            onClose();
            deleteSingleReport.reset();
        }
    }, [deleteSingleReport, onClose, onSuccess]);

    return (
        <Modal
            dataTestId='delete-merchant-modal'
            isOpen={isOpen}
            closeModal={onClose}
            status='warning'
            containerClass={styles.modalContainer}
        >
            <Modal.Title
                id='delete-merchant-title'
                title={t('Delete Merchant')}
                statusIcon='warning'
                onClose={onClose}
            />
            <div className={styles.deleteWarningContent}>
                <div className={styles.merchantInfo}>{t('delete merchant warning', { merchantId })}</div>
                {t('This cannot be undone You will have to add this Merchant again')}.
            </div>
            <Modal.Footer
                id='delete-merchant-footer'
                onAction={() => deleteSingleReport.mutate('')}
                disableOnAction={deleteSingleReport.isLoading}
                onActionText={t('Delete')}
                onClose={onClose}
                onCloseText={t('Cancel')}
            />
        </Modal>
    );
};

export default DeleteMerchantModal;
